module.exports = __webpack_public_path__ + "img/binding_mb_tab_04.7dd0f722.png";